// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false;

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'

import '@/common/css/flex.less'

// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
Vue.use(ElementUI);
Vue.use(VueResource);
//Vue.use(VueQuillEditor);



import {get, post, host,PLATFORM} from '@/http/http.js'
import {post1} from '@/http/http.js'
Vue.prototype.$chatHost = host;
Vue.prototype.$platform = PLATFORM;
Vue.prototype.$get = get;
// Vue.prototype.$getSync = getSync;
Vue.prototype.$post = post;
Vue.prototype.$postFile = post1;
//Vue.prototype.$imageUploadPath = host+'/upload/image/';
Vue.prototype.$imageUploadPath = host+'/upload/image/';
Vue.prototype.$fileUploadPath = host+'/upload/file/';
Vue.prototype.$fileUploadPathMeta = host+'/upload/file/?meta=1';



import FileUpload from "@/components/FileUpload"
Vue.component('FileUpload', FileUpload);

import ImageUpload from "@/components/ImageUpload"
Vue.component('ImageUpload', ImageUpload);


import Qrcode from '@/components/Qrcode.vue'
Vue.component('Qrcode', Qrcode);

import Poster from '@/components/Poster';
Vue.component('Poster', Poster);

import CommonCat from '@/components/CommonCat'
Vue.component('CommonCat', CommonCat);

import TextGenerate from "@/components/TextGenerate"
Vue.component('TextGenerate', TextGenerate);


// import ECharts from 'vue-echarts/components/ECharts'
// Vue.component('chart', ECharts);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});

router.beforeEach((to, from, next) => {
  // console.log(to);
  // console.log(from);
  if (to.meta.requireAuth) {
    if (localStorage.getItem('token')) {
      next();
    } else {
      next({
        path: '/login'
      })
    }
  }
  else {
    next();
  }
  if (to.fullPath == "/login") {
    if (localStorage.getItem('token')) {
      next({
        path: from.fullPath
      });
    } else {
      next();
    }
  }
});
